webpackJsonp([225421255713772],{

/***/ 267:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>Posts are automatically created at the path defined above in the frontmatter. They use the same template (defined above).</p>\n<p>Here’s another sloth.</p>\n<p><img src=\"/assets/sloth2.png\" alt=\"needs alt text I think\"></p>","frontmatter":{"path":"/test-post-2","title":"Text Post Two"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---test-post-2-21422c78cce1bdbbbc00.js